function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "square"
}, React.createElement("path", {
  d: "M12 1.429V19.57M.462 9.423l11.076 10.154M12 20L23 9"
}));

var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 21"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgdHJhbnNmb3JtPSJtYXRyaXgoMCAxIDEgMCAwIDEpIj48cGF0aCBkPSJtLjQyODU3MSAxMmgxOC4xNDI4NTciLz48cGF0aCBkPSJtOC40MjMwNzcuNDYxNTM4IDEwLjE1Mzg0NiAxMS4wNzY5MjQiLz48cGF0aCBkPSJtMTkgMTItMTEgMTEiLz48L2c+PC9zdmc+Cg==";
export { SvgIconArrowDown as ReactComponent };